import { FC, HTMLAttributes, MouseEventHandler, ReactNode } from 'react';
import type { I18NInterface } from '../../../utils';
import { Button, Pictogram } from '../../../core-components';
type Element = Omit<HTMLAttributes<HTMLDivElement>, 'onClick' | 'children'>;
export type CookieConsentFallbackProps = Element & {
  i18n?: I18NInterface<'consentMessage', ReactNode> & I18NInterface<'consentButtonLabel'>;
  onClick?: MouseEventHandler<HTMLButtonElement>;
};
export const CookieConsentFallback: FC<CookieConsentFallbackProps> = ({
  i18n,
  onClick,
  ...attrs
}) => {
  return <div {...attrs} className="max-h-[95%] max-w-[95%] space-y-4 overflow-y-scroll rounded-md bg-white/95 p-6 pt-5 text-center text-lg text-marine-high-emphasis scrollbar-hidden md:max-w-[378px] md:space-y-8 md:p-10 md:text-base" data-sentry-component="CookieConsentFallback" data-sentry-source-file="CookieConsentFallback.tsx">
      <div className="space-y-2">
        <Pictogram name="play-button" size="md" className="hidden md:inline-block" data-sentry-element="Pictogram" data-sentry-source-file="CookieConsentFallback.tsx" />

        <div className="[&>a]:text-ocean-120 [&>a]:underline [&>a]:hover:no-underline">
          {i18n?.consentMessage ?? 'When playing the video, personal data may be transferred to YouTube. More about this in our privacy policy.'}
        </div>
      </div>

      <Button variant="primary" onClick={onClick} hasFullWidthOnMobile data-sentry-element="Button" data-sentry-source-file="CookieConsentFallback.tsx">
        {i18n?.consentButtonLabel ?? 'Activate Video'}
      </Button>
    </div>;
};